import React, { useEffect } from "react";
import useLogout from "./hooks/useLogout";
import { Routes, Route } from "react-router-dom";
// import axios from "./api/axios";
// import axios from "axios";
import "./App.css";
import Layout from "./Components/Layouts/Layout";
import Register from "./Components/Register/Register";
import Login from "./Components/Login/Login";
import Unauthorized from "./Components/Unauthorized/Unauthorized";
import PersistLogin from "./Components/Login/PersistLogin";
import MainLayout from "./Components/Layouts/MainLayout";
import RequireAuth from "./Components/RequireAuth/RequireAuth";
import SocketWrapper from "./Components/Wrappers/SocketWrapper";
import SessionTimeoutWrapper from "./Components/Wrappers/SessionTimeoutWrapper";
import TopNavLayout from "./Components/Layouts/TopNavLayout";
import Dashboard from "./Components/Dashboard/Dashboard";
import AdminOutlet from "./Components/Admin/AdminOutlet";
import Products from "./Components/Products/Products";
import ProductDetails from "./Components/Products/ProductDetails";
import Suppliers from "./Components/Suppliers/Suppliers";
import SupplierDetails from "./Components/Suppliers/SupplierDetails";
import Customers from "./Components/Customers/Customers";
import CustomerDetails from "./Components/Customers/CustomerDetails";
import Users from "./Components/Users/Users";
import UserDetails from "./Components/Users/UserDetails";
import PositionsOutlet from "./Components/Positions/PositionsOutlet";
import Positions from "./Components/Positions/Positions";
import PositionsSupplier from "./Components/Positions/PositionsSupplier";
import PositionsUSA from "./Components/Positions/PositionsUSA";
import QSOutlet from "./Components/QS/QSOutlet";
import QS from "./Components/QS/QS";
import QSUSA from "./Components/QS/QSUSA";
import PositionReportUSA from "./Components/Positions/PositionReportUSA";
import LogisticsOutlet from "./Components/Logistics/LogisticsOutlet";
import InProgress from "./Components/Logistics/InProgress";
import PositionsSpain from "./Components/Positions/PositionsSpain";
import QSSP from "./Components/QS/QSSP";
import PositionReportSpain from "./Components/Positions/PositionReportSpain";

function App() {
  // Code snippet below forces logout when browser window is closed. but then persisten login doesn't work because refreshing browser is recognized the same as closing the window.

  // const logout = useLogout();
  // useEffect(() => {
  //   const handleBeforeUnload = (e) => {
  //     logout();
  //     e.preventDefault(); // Some browsers require this
  //     e.returnValue = ""; // For older browsers
  //   };
  //   window.addEventListener("beforeunload", handleBeforeUnload);
  //   return () => {
  //     window.removeEventListener("beforeunload", handleBeforeUnload);
  //   };
  // }, []);

  return (
    <Routes>
      <Route path='/' element={<Layout />}>
        {/* public routes*/}
        <Route path='/register' element={<Register />} />
        <Route path='/login' element={<Login />} />
        <Route path='/unauthorized' element={<Unauthorized />} />

        {/* protected routes */}
        <Route path='/' element={<PersistLogin />}>
          <Route path='/' element={<MainLayout />}>
            <Route path='/' element={<SocketWrapper />}>
              <Route path='/' element={<SessionTimeoutWrapper />}>
                <Route path='/' element={<TopNavLayout />}>
                  <Route element={<RequireAuth allowedRoles={[2020]} />}>
                    <Route path='/admin' element={<AdminOutlet />}>
                      <Route path='/admin/products' element={<Products />}>
                        <Route path='/admin/products/productdetails' element={<ProductDetails />} />
                      </Route>
                      <Route path='/admin/suppliers' element={<Suppliers />}>
                        <Route path='/admin/suppliers/supplierdetails' element={<SupplierDetails />} />
                      </Route>
                      <Route path='/admin/customers' element={<Customers />}>
                        <Route path='/admin/customers/customerdetails' element={<CustomerDetails />} />
                      </Route>
                      <Route path='/admin/users' element={<Users />}>
                        <Route path='/admin/users/userdetails' element={<UserDetails />} />
                      </Route>
                    </Route>
                  </Route>
                  <Route element={<RequireAuth allowedRoles={[2020, 2222]} />}>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/positions' element={<PositionsOutlet />}>
                      <Route path='/positions/' element={<Positions />} />
                      <Route path='/positions/reportusa' element={<PositionReportUSA />} />
                      <Route path='/positions/reportspain' element={<PositionReportSpain />} />
                      <Route path='/positions/supplier' element={<PositionsSupplier />} />
                      <Route path='/positions/usa' element={<PositionsUSA />} />
                      <Route path='/positions/spain' element={<PositionsSpain />} />
                    </Route>
                  </Route>
                  <Route element={<RequireAuth allowedRoles={[2020, 2222]} />}>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/qs' element={<QSOutlet />}>
                      <Route path='/qs/' element={<QS />} />
                      <Route path='/qs/usa' element={<QSUSA />} />
                      <Route path='/qs/spain' element={<QSSP />} />
                    </Route>
                  </Route>
                  <Route element={<RequireAuth allowedRoles={[2020, 2222]} />}>
                    <Route path='/' element={<Dashboard />} />
                    <Route path='/logistics' element={<LogisticsOutlet />}>
                      <Route path='/logistics/inprogress' element={<InProgress />} />
                    </Route>
                  </Route>
                </Route>
              </Route>
            </Route>
          </Route>
        </Route>
      </Route>
    </Routes>
  );
}

export default App;
